import { SxProps } from '@mui/system';

export const fieldsRowStyles: SxProps = {
  marginBottom: 4,
};

export const sectionTitleStyles: SxProps = {
  marginBottom: 2,
};
